<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.setting', 2) }}
          <v-btn color="primary" v-if="$auth.isDev()" @click="goTo('newSetting')"> {{ $t('create') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(settings, ns) in grouped" :key="ns">
            <template v-slot:header>
              <div>{{ $t(`setting_namespace.${ns || 'other'}`) }}</div>
            </template>

            <v-card>
              <v-card-text>
                <v-data-table class="elevation-1"
                  :items="settings"
                  :loading="loading"
                  hide-headers
                  hide-actions
                  :no-data-text="$t('noDataAvailable')">
                  <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                  <template v-slot:items="props">
                    <tr v-if="props.item.visible ||  $auth.isDev()">
                      <td>
                        {{ props.item.title }}
                        <br />
                        <b> {{ props.item.value }} </b>
                      </td>
                      <td class="pa-0 pr-2 text-xs-right">
                        <v-btn color="primary" flat icon @click="goTo('editSetting', props.item.id)" v-can:update="'Setting'">
                          <font-awesome-icon icon="edit"></font-awesome-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { groupBy } from 'lodash'

import Setting from '@/client/setting'

export default {
  name: 'SettingsView',

  props: {},

  data () {
    return {
      items: [],
      loading: false
    }
  },

  components: {
  },

  computed: {
    grouped() {
      return groupBy(this.items, 'namespace')
    }
  },

  methods: {
    async fetch () {
      this.loading = true
      this.items = await Setting.all({
        per_page: 2000
      })
      this.loading = false
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
  }
}
</script>
